import { Component, OnInit } from '@angular/core';
import { DialogService } from '@service/dialog.service';
import { MobileService } from '@service/mobile.service';
import { UserService } from '@service/user/user.service';

@Component({
  selector: 'newsfeed-top-banner',
  templateUrl: './newsfeed-top-banner.component.html',
  styleUrls: ['./newsfeed-top-banner.component.scss'],
  host: {
    '[class.is-logged-in]': 'userService.isLoggedIn',
  },
})
export class NewsfeedTopBannerComponent {
  constructor(
    public userService: UserService,
    public dialogService: DialogService,
    public mobileService: MobileService,
  ) {}

  get desktopAndTabletTopText(): string {
    return this.userService.isLoggedIn
      ? 'Gemeinsam stark für den Holzbau!'
      : 'Profitiere auch Du vom Netzwerk im Zimmerer-Treffpunkt.';
  }

  get desktopBottomText(): string {
    return this.userService.isLoggedIn
      ? 'Teile dein Wissen und profitiere von den Erfahrungen anderer. Hier kannst Du Zimmereibedarf verkaufen, Mitarbeiter oder Jobs finden, dich weiterbilden und dein Handwerk mitgestalten.'
      : 'Hier helfen Zimmerer anderen Zimmerern. Registriere dich jetzt kostenlos und melde dich an.';
  }

  get tabletBottomText(): string {
    return this.userService.isLoggedIn
      ? 'Gemeinsam stark für den Holzbau! Hilf deinen Berufskollegen mit hilfreichen Beiträgen oder Kommentaren und vervollständige dein Profil. Werde aktiv, sammle Woodcoins und räume tolle Preise ab!'
      : 'Hier helfen Zimmerer anderen Zimmerern. Registriere dich jetzt kostenlos und melde dich an.';
  }

  get mobileTopText(): string {
    return this.userService.isLoggedIn ? '' : 'Profitiere<br>auch Du vom<br>Netzwerk im';
  }

  get mobileTopTextLastLine(): string {
    return this.userService.isLoggedIn ? '' : 'Zimmerer-Treffpunkt';
  }

  // TODO maybe move only the first line
  get mobileBottomText(): string {
    return this.userService.isLoggedIn
      ? '<strong>Gemeinsam stark für den Holzbau!</strong> Teile dein Wissen und profitiere von den Erfahrungen anderer. Hier kannst Du Zimmereibedarf verkaufen, Mitarbeiter oder Jobs finden, dich weiterbilden und dein Handwerk mitgestalten.'
      : 'Hier helfen Zimmerer anderen Zimmerern. Registriere dich jetzt kostenlos und melde dich an.';
  }
}
